export default class File {
	constructor(domElement, data) {
		try {
			this.element = domElement;
			this.config = {
				visible: true,
				hiddenClass: 'hidden',
				selectorTopCat: '.js-dc-file-top-category'
			};
			this.data = data;

			this.data.topCategory = this.element.querySelector(this.config.selectorTopCat) ? this.element.querySelector(this.config.selectorTopCat).innerHTML.replace(/(\r\n|\n|\r|\t)/gm,"") : false;

			this.data.mapCategories = {};
			if (typeof(this.data.categories) === 'undefined' || this.data.categories.length === 0) {
				this.setVisibility(false);
			} else {
				for (let i = 0; i < this.data.categories.length; i++) {
					this.data.mapCategories[ this.data.categories[i].uid ] = true;
					this.data.mapCategories[ this.data.categories[i].l10n_parent ] = true;
				}
			}

			this.data.mapKeywords = {};
			if (typeof(this.data.keywords) === 'string') {
				this.data.keywords.toLowerCase().split(',').forEach(keyword => {
					this.data.mapKeywords[ keyword.trim() ] = true;
				});
			}
		} catch (e) {
			console.error(e);
		}
	}

	/**
	 * Get the file's uid.
	 * 
	 * @returns {integer}
	 */
	getUid() {
		return this.data.uid;
	}

	/**
	 * The DOM element of this category.
	 * 
	 * @returns {HTMLElement}
	 */
	getElement() {
		return this.element;
	}

	/**
	 * Gets the data associated with this file.
	 * 
	 * @returns {Object}
	 */
	getData() {
		return this.data;
	}

	/**
	 * Get the file's top-category.
	 * 
	 * @returns {string}
	 */
	getTopCategory() {
		return this.data.topCategory;
	}

	/**
	 * Checks if file has a speific category set.
	 * 
	 * @param	{integer}	categoryUid	The category uid to check.
	 * @returns	{boolean}
	 */
	hasCategory(categoryUid) {
		return this.data.mapCategories[categoryUid];
	}

	/**
	 * Same as hasCategory just for keywords.
	 * 
	 * @param	{string}	keyword
	 * @returns	{boolean}
	 */
	hasKeyword(keyword) {
		return this.data.mapKeywords[keyword];
	}

	/**
	 * Searches inside file data for a specific keyword.
	 * 
	 * @param {string} keyword 
	 * @returns {boolean}
	 */
	searchFile(keyword) {
		return this.data.mapKeywords[keyword] || this.data.title?.toLowerCase().indexOf(keyword) > -1 || this.data.description?.toLowerCase().indexOf(keyword) > -1;
	}

	/**
	 * Gets the categories this file is assigned to.
	 * 
	 * @returns {Array}
	 */
	getCategories() {
		return this.data?.categories || [];
	}

	/**
	 * Gets visibility state.
	 * 
	 * @returns {boolean}
	 */
	isVisible() {
		return this.config.visible;
	}

	/**
	 * Sets visibility state.
	 * 
	 * @param {boolean} bVisible 	True or false.
	 */
	setVisibility(bVisible) {
		this.config.visible = bVisible;
		if (bVisible) {
			this.element.classList.remove(this.config.hiddenClass);
		} else {
			this.element.classList.add(this.config.hiddenClass);
		}
	}
}
